import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Carousel } from 'primereact/carousel';
import BaseCard from '../../components/misc/BaseCard.jsx';
import company from '../../resources/images/company.png';
import { useNavigate } from 'react-router-dom';
import IconFilter from '../../components/images/IconFilter';
import { formatNumbers } from '../../utils/formatNumbers.js';

const DashboardCompanyCarousel = ({ className, items, page }) => {
    const navigate = useNavigate();

    const handleCardClick = (item) => {
        navigate('/contacts/advanced-search', {
            state: { filters: { companies: [item.id] }, backRoute: window.location.pathname }
        });
    };

    const dashboardItemTemplate = (item) => {
        return (
            <div className='mr-4'>
                <BaseCard
                    className='mr-4 my-4 p-4 relative rounded-2xl min-h-[130px] shadow-mildSubtleRight'
                    onClick={() => handleCardClick(item)}
                >
                    <IconFilter className='fill-theme1-title2 absolute right-3 top-3 w-5 h-5' />
                    <div className='text-[50px] font-bold text-center text-theme1-gold'>
                        {formatNumbers(Number(item.count))}
                    </div>
                    <div className='w-full flex items-center justify-center'>
                        <div className='mr-2 w-4 h-4 flex items-center justify-center flex-shrink-0'>
                            <img alt='' src={company} className='w-12 h-auto' />
                        </div>
                        <div>
                            <div className='text-theme1-title2 font-bold text-xs'>{item.name}</div>
                        </div>
                    </div>
                </BaseCard>
            </div>
        );
    };

    return (
        <div className={twMerge('', className)}>
            <Carousel
                value={items}
                numScroll={1}
                numVisible={2}
                itemTemplate={dashboardItemTemplate}
                showNavigators={false}
                circular={false}
                showIndicators
                page={page || 0}
            />
        </div>
    );
};

export default DashboardCompanyCarousel;
